module.exports = __webpack_public_path__ + "assets/webgl/Frame_Painting_materialParams.1001.8c78c69e.jpg";